// used in the user application list
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  close(event) {
    event.preventDefault()

    const closableElement = event.target.closest('[data-closable]')
    if (closableElement) {
      closableElement.style.transition = 'opacity 0.3s ease-in-out'
      closableElement.style.opacity = '0'

      setTimeout(() => {
        closableElement.remove()
      }, 300)
    }
  }
}
